import { RowHeight, RowHeights } from '@mode/reports/sandbox/contract';
import { Observable } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { MixableBaseController } from '~/common/component';
import { ROW_HEIGHT_ATTR, TEXT_BLOCK_MARGINS_CLASS } from '../../common/constants';

import { EmbedBuilderActions } from '@mode/reports/sandbox/contract';
import { ofType } from '@mode/legacy/util-domain';
import { AppStore } from '~/types/main.types';

import { Actions } from '../../actions';

export default class TextBlockController extends MixableBaseController {
  static $inject = ['$element', '$attrs', 'RxStoreService', 'actions$'];

  public view: {
    textContents: string;
  };

  public editor: any;
  public token: string;

  textContent: string; // set if running in new embed
  onRemove: (args: { $id: string }) => void;
  textChanged: (args: { $id: string; $text: string }) => void;
  onToggleMargins: (args: { $id: string }) => void;
  onSetRowHeight: (args: { $size: RowHeight }) => void;

  constructor(
    private $element,
    private $attrs,
    private store: AppStore,
    private actions$: Observable<Actions>
  ) {
    super();
  }

  toggleSizePicker() {
    this.$element.parents('mode-text').find('.text-block-size-dropdown').toggleClass('active');
  }

  getRowHeight = () => {
    const current = this.$element.parents('.row').attr(ROW_HEIGHT_ATTR) as RowHeight;
    if (current) {
      return current;
    }

    return this.$element.parents('[class^=col-md]').hasClass('col-md-12') ? RowHeights.Full : RowHeights.Default;
  };

  setRowHeight = (size: RowHeight) => {
    this.onSetRowHeight({ $size: size });
  };

  resizeElement = () => {
    const resizeContainer = this.$element.find('.resize.resize-hover');
    resizeContainer.css('height', this.$element.find('.text-block-container').css('height'));
  };

  onTextChange = (contents) => {
    if (this.$element.find('.text-block-container').hasClass('selected')) {
      this.resizeElement();
    }
    this.saveTextBlock(contents);
  };

  saveTextBlock = (contents) => {
    this.textChanged({ $id: this.$attrs.id, $text: contents });
  };

  removeTextBlock = () => {
    this.onRemove({ $id: this.$attrs.id });
  };

  toggleMargins = () => {
    this.onToggleMargins({ $id: this.$attrs.id });
  };

  hasMargins = () => this.$element.parent().hasClass(TEXT_BLOCK_MARGINS_CLASS);

  $onInit() {
    this.actions$
      .pipe(
        takeUntil(this.destroyed$),
        ofType(EmbedBuilderActions.Type.EditText),
        filter(({ token }) => token === this.token)
      )
      .subscribe(() => {
        if (this.editor) {
          this.editor.onEdit();
        }
      });
  }
  $onDestroy = () => {
    this.$element.off('click');
    this.$element.off('dblclick');
    $(document).off('.text-block');
  };
}
